// ModalReserva.js
import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Container, Row, Col } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../componentes/ModalReserva.css';
import logo from '../data/inicio/logo.png';
import Alerta from '../componentes/Alerta';

const ModalReserva = ({ show, onHide }) => {
  const [step, setStep] = useState(1);
  const tasaCambio = 95;

  const [formData, setFormData] = useState({
    numeroOperacion: '',
    fechaOperacion: new Date(),
    nombres: '',
    apellidos: '',
    cedula: '',
    telefono: '',
    email: '',
    monto: ''
  });

  const [formErrors, setFormErrors] = useState({});

  // Mostrar alerta al abrir el modal
  useEffect(() => {
    if(show) {
      Alerta({
        type: 'info',
        title: '🔐 Política de Reserva',
        content: `
          <div class="custom-swal-instruction">
            <p style="font-size: 1.1rem; margin-bottom: 1.5rem;">
              <span style="color: #98ca3f;">¡Asegura tu lugar por solo $2 USD!</span>
            </p>
            
            <ul style="text-align: left; padding-left: 1.5rem; margin-bottom: 1.5rem;">
              <li>🚀 <strong>Garantiza</strong> tu cupo en el curso</li>
              <li>📝 Cubre <strong>gastos administrativos</strong> iniciales</li>
              <li>🔒 Monto <strong>no reembolsable</strong></li>
            </ul>

            <p style="font-size: 0.95rem; margin-top: 1.5rem;">
              ¿Necesitas más detalles? 
              <a href="/preguntas-frecuentes#reservas" 
                style="color: #98ca3f; text-decoration: underline;"
                target="_blank"
                rel="noopener noreferrer">
                Ver política completa
              </a>
            </p>
          </div>
        `,
        logoUrl: logo,
        logoClass: 'logo-verificacion',
        options: {
          confirmButtonText: 'Acepto las condiciones',
          cancelButtonText: 'Cancelar proceso',
          showCancelButton: true
        }
      });
    }
  }, [show]);


  const validateStep = () => {
    const errors = {};

    if(step === 1) {
      if(!formData.numeroOperacion.trim()) {
        errors.numeroOperacion = 'El número de operación es requerido';
      }
      if(!formData.fechaOperacion) {
        errors.fechaOperacion = 'Seleccione la fecha de la operación';
      }
      if(!formData.monto.trim()) {
        errors.monto = 'El monto es requerido';
      }
    }

    if(step === 2) {
      const requiredFields = {
        nombres: 'Ingrese sus nombres',
        apellidos: 'Ingrese sus apellidos',
        cedula: 'Ingrese su número de cédula',
        telefono: 'Ingrese su número telefónico',
        email: 'Ingrese su correo electrónico'
      };

      Object.entries(requiredFields).forEach(([field, message]) => {
        if (!formData[field].trim()) errors[field] = message;
      });

      if(formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
        errors.email = 'Ingrese un correo electrónico válido';
      }
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if(formErrors[name]) setFormErrors(prev => ({ ...prev, [name]: null }));
  };

  const handleNext = () => {
    if(!validateStep()) return;
    setStep(2);
  };

  const handleSubmit = () => {
    if (!validateStep()) return;
  
    const formatDate = (date) => {
      return new Intl.DateTimeFormat('es-VE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).format(formData.fechaOperacion);
    };
  
    const message = `🎟️ *ACADEMIA PIXEL* 🎟️
  **NUEVA RESERVA CONFIRMADA**
  --------------------------------
  📄 *N° Operación:* ${formData.numeroOperacion}
  📅 *Fecha:* ${formatDate(formData.fechaOperacion)}
  💵 *Monto:* ${formData.monto} Bs.D
  
  ================================
  👤 *DATOS PERSONALES*
  --------------------------------
  ▫️ *Nombre:* ${formData.nombres.toUpperCase()} ${formData.apellidos.toUpperCase()}
  ▫️ *Cédula:* ${formData.cedula}
  ▫️ *Teléfono:* ${formData.telefono}
  📧 *Email:* ${formData.email}
  
  ================================
  💱 *Tasa de cambio aplicada:*
  ${tasaCambio.toFixed(2)} Bs.D`;
  
    const url = `https://wa.me/584124077973?text=${encodeURIComponent(message)}`;
    console.log(url); // Imprime la URL en la consola para verificar la codificación
  
    window.open(url, '_blank');
    onHide();
  };
  
  

  return (
    <Modal show={show} onHide={onHide} size="lg" centered className="reserva-modal" backdrop="static">
      <Modal.Header closeButton className="modal-header-custom">
        <Modal.Title className="d-flex align-items-center gap-2">
          <img src={logo} alt="Logo" className="modal-logo" />
          Reserva de Cupo {step}/2
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="modal-body-custom">
        <Container fluid>
          {step === 1 && (
            <Row>
              <Col md={6}>
                <h4 className="bank-data-title">Instrucciones de Pago</h4>
                <div className="bank-info-container">
                  <div className="conversion-container mb-4">
                    <h5 className="bank-instruction">Monto a Pagar:</h5>
                    <div className="d-flex justify-content-between">
                      <span>$2 USD</span>
                      <span>≈ {(2 * tasaCambio).toLocaleString('es-VE', {
                        style: 'currency',
                        currency: 'VES',
                        minimumFractionDigits: 2
                      })}</span>
                    </div>
                  </div>

                  <div className="bank-instructions">
                    <p>Realiza el pago de $2 USD a:</p>
                    <ul>
                      <li>Banco: 0134 BANESCO</li>
                      <li>Teléfono: 0412-4077973</li>
                      <li>Cédula: V-17032531</li>
                    </ul>
                  </div>
                </div>
              </Col>

              <Col md={6}>
                <h4 className="form-title">Paso 1: Datos de Transacción</h4>

                <Form.Group className="mb-3">
                  <Form.Label className="input-label">Número de Operación</Form.Label>
                  <Form.Control
                    type="text"
                    name="numeroOperacion"
                    value={formData.numeroOperacion}
                    onChange={handleChange}
                    isInvalid={!!formErrors.numeroOperacion}
                    placeholder="Ejemplo: 123456789"
                  />
                  <Form.Control.Feedback type="invalid">
                    {formErrors.numeroOperacion}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="input-label">Fecha de Operación</Form.Label>
                  <DatePicker
                    selected={formData.fechaOperacion}
                    onChange={(date) => setFormData({...formData, fechaOperacion: date})}
                    className={`form-control ${formErrors.fechaOperacion ? 'is-invalid' : ''}`}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="Seleccione una fecha"
                  />
                  {formErrors.fechaOperacion && (
                    <div className="invalid-feedback d-block">
                      {formErrors.fechaOperacion}
                    </div>
                  )}
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="input-label">Monto (Bs.D)</Form.Label>
                  <Form.Control
                    type="text"
                    name="monto"
                    value={formData.monto}
                    onChange={handleChange}
                    isInvalid={!!formErrors.monto}
                    placeholder="Ejemplo: 190.00"
                  />
                  <Form.Control.Feedback type="invalid">
                    {formErrors.monto}
                  </Form.Control.Feedback>
                </Form.Group>

                <div className="d-grid gap-2 mt-4">
                  <Button variant="success" onClick={handleNext}>
                    Verificar Datos →
                  </Button>
                </div>
              </Col>
            </Row>
          )}

          {step === 2 && (
            <Row>
              <Col md={12}>
                <h4 className="form-title">Paso 2: Datos Personales</h4>

                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label className="input-label">Nombres</Form.Label>
                      <Form.Control
                        type="text"
                        name="nombres"
                        value={formData.nombres}
                        onChange={handleChange}
                        isInvalid={!!formErrors.nombres}
                        placeholder="Ejemplo: María José"
                      />
                      <Form.Control.Feedback type="invalid">
                        {formErrors.nombres}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label className="input-label">Apellidos</Form.Label>
                      <Form.Control
                        type="text"
                        name="apellidos"
                        value={formData.apellidos}
                        onChange={handleChange}
                        isInvalid={!!formErrors.apellidos}
                        placeholder="Ejemplo: Pérez González"
                      />
                      <Form.Control.Feedback type="invalid">
                        {formErrors.apellidos}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label className="input-label">Cédula</Form.Label>
                      <Form.Control
                        type="text"
                        name="cedula"
                        value={formData.cedula}
                        onChange={handleChange}
                        isInvalid={!!formErrors.cedula}
                        placeholder="Ejemplo: V-12345678"
                      />
                      <Form.Control.Feedback type="invalid">
                        {formErrors.cedula}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label className="input-label">Teléfono WhatsApp</Form.Label>
                      <Form.Control
                        type="tel"
                        name="telefono"
                        value={formData.telefono}
                        onChange={handleChange}
                        isInvalid={!!formErrors.telefono}
                        placeholder="Ejemplo: 04121234567"
                      />
                      <Form.Control.Feedback type="invalid">
                        {formErrors.telefono}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label className="input-label">Correo Electrónico</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        isInvalid={!!formErrors.email}
                        placeholder="Ejemplo: usuario@correo.com"
                      />
                      <Form.Control.Feedback type="invalid">
                        {formErrors.email}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
        </Container>
      </Modal.Body>

      <Modal.Footer className="modal-footer-custom">
        <Button variant="secondary" onClick={onHide}>
          Cancelar
        </Button>

        {step === 2 && (
          <Button variant="success" onClick={handleSubmit}>
            Enviar Confirmación ✅
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ModalReserva;
